import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { EpubReaderView } from 'src/components/material/reader-poc/epubFoliateAdapter';
import { FixtureReaderPage } from 'src/components/material/reader-poc/FixtureReaderPage';
import epubFixtureUrl from 'src/components/material/reader-poc/fixtures/alice.epub?url';

import type { ReaderDocument } from 'src/components/material/reader-poc/types';

/**
 * EPUB showcase: the shell driving the Foliate adapter against the bundled
 * "Alice's Adventures in Wonderland" fixture (public domain).
 *
 * Unauthenticated on purpose — see `FixtureReaderPage` for why.
 */
const EpubReaderPocPage = () => {
  const epubDocument = useMemo<ReaderDocument>(
    () => ({
      id: 'fixture-epub-alice',
      kind: 'epub',
      title: "Alice's Adventures in Wonderland",
      source: { kind: 'url', url: epubFixtureUrl },
    }),
    []
  );

  return <FixtureReaderPage document={epubDocument} View={EpubReaderView} />;
};

export const Route = createFileRoute('/reader-poc/epub')({
  component: EpubReaderPocPage,
});
